export default __webpack_public_path__ + "static/media/hexmaze.3f645810.png";